import {flow, types} from 'mobx-state-tree';
import * as api from '../../services/api';
import PaginationModel from '../PaginationModel';
import {
  StaahListingItemModel,
  StaahListingItemModelType
} from '../StaahListingDetailModel/StaahListingDetailModel';
export type ListingModelViews = {
  previewImageUrl?: string;
};

export const V3ListingModel = types.model('V3Listing', {
  id: types.identifierNumber,
  name: types.string,
  internalName: types.maybe(types.string),
  staahListingId: types.maybeNull(types.string),
  staahRateId: types.maybeNull(types.string)
});

export type V3ListingModelType = typeof V3ListingModel.Type;

// tslint:disable
export type ListingsListActions = {
  loadEntries: (offset?: number, limit?: number) => void;
  // tslint:disable-next-line:no-any
  receiveEntries: (data: any) => void;
  loadNextPage: () => void;
  loadPreviousPage: () => void;
};

export const V3ListingListModel = types
  .model({
    isLoading: types.optional(types.boolean, false),
    isLoaded: types.optional(types.boolean, false),
    entries: types.map(V3ListingModel),
    pagination: types.optional(PaginationModel, {}),

    // Is editing staah mapping
    currentStaahListing: types.maybe(types.reference(StaahListingItemModel)),
    currentEditingV3ListingName: types.maybe(types.string),
    currentEditingV3ListingId: types.maybe(types.number),
    isEditingV3Listing: types.optional(types.boolean, false)
  })
  .actions(self => {
    // tslint:disable-next-line:no-any
    const withActions = (self as any) as ListingsListActions;

    return {
      // tslint:disable-next-line:no-any
      loadEntries: flow(function*(params: any) {
        self.isLoading = true;
        const response = yield api.getV3Listings(params);
        if (response.status === 200 && response.data) {
          const {count} = response.data;
          self.pagination.offset = 0;
          self.pagination.limit = 100;
          self.pagination.total = count;

          const results = response.data.results || [];
          // tslint:disable-next-line:no-any
          const listings = results.map((listing: any) => {
            return {
              id: listing.id,
              name: listing.name,
              staahListingId: listing.staahListingId,
              staahRateId: listing.staahRateId
            };
          });
          withActions.receiveEntries(listings);

          self.isLoading = false;
          self.isLoaded = true;
        }
      }),
      updateStaahListingMapping: flow(function*(
        staahListingId: string,
        staahRateId: string,
        // tslint:disable-next-line:no-any
        callback: any
      ) {
        if (!self.currentEditingV3ListingId) {
          return;
        }
        const response = yield api.updateStaahListingMapping(
          self.currentEditingV3ListingId,
          staahListingId,
          staahRateId
        );

        if (response.status === 200 && response.data) {
          const listing = response.data;
          self.entries.set(String(listing.id), listing);
          callback('success', 'Update successfully');
        } else {
          callback('error', 'Update error');
        }
      }),
      // tslint:disable-next-line:no-any
      receiveEntries: (entries: any) => {
        if (!entries || entries.length === 0) {
          return;
        }
        // tslint:disable-next-line:no-any
        const received = entries.reduce((ts: any, t: any) => {
          ts[String(t.id)] = t;
          return ts;
        }, {});

        self.entries.merge(received);
      },
      setCurrentStaahListing: (listing: StaahListingItemModelType) => {
        self.currentStaahListing = listing;
      },
      setCurrentEditingV3ListingName: (listingName: string) => {
        self.currentEditingV3ListingName = listingName;
      },
      setCurrentEditingV3ListingId: (listingId: number) => {
        self.currentEditingV3ListingId = listingId;
      },
      toggleIsEditingV3Listing: () => {
        self.isEditingV3Listing = !self.isEditingV3Listing;
      }
    };
  });

export type V3ListingListModelType = typeof V3ListingListModel.Type;

export default V3ListingListModel;



// WEBPACK FOOTER //
// ./src/models/V3ListingListModel/V3ListingListModel.ts